/* eslint-disable no-fallthrough */
export const realtimeInventoryState = {
  fromDate: "",
  toDate: "",
  agentName: "",
  productCategory: "",
  productName: "",
  brand: "",
  customerName:"",
  rating:"",
  market:"",
  roleName:"",
  deliveryStatuses:"",
  quantity:'',
  ageofStock:"",
  approval:"",

  // status
  fromDateStatus: "unchecked",
  toDateStatus: "unchecked",
  agentNameStatus: "unchecked",
  productCategoryStatus: "unchecked",
  productNameStatus: "unchecked",
  brandStatus: "unchecked",
  customerNameStatus: "unchecked",
  ratingStatus: "unchecked",
  marketStatus: "unchecked",
  roleNameStatus:"unchecked",
  deliveryStatusesStatus:"unchecked",
  quantityStatus:"unchecked",
  ageofStockStatus:"unchecked",
  approvalStatus:"unchecked"
};

export const RealtimeInventoryStateMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "reset": {
      return { ...realtimeInventoryState }; // Return the initial state
    }
    case "agentName": {
      if (value) {
        return {
          ...state,
          agentName: value,
          agentNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          agentName: "",
          agentNameStatus: "unchecked",
        };
      }
    }
    case "approval": {
      if (value) {
        return {
          ...state,
          approval: value,
          approvalStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          approval: "",
          approvalStatus: "unchecked",
        };
      }
    }
    case "productCategory": {
      if (value) {
        return {
          ...state,
          productCategory: value,
          productCategoryStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productCategory: "",
          productCategoryStatus: "unchecked",
        };
      }
    }
    case "productName": {
      if (value) {
        return {
          ...state,
          productName: value,
          productNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productName: "",
          productNameStatus: "unchecked",
        };
      }
    }
    case "brand": {
      if (value) {
        return {
          ...state,
          brand: value,
          brandStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          brand: "",
          brandStatus: "unchecked",
        };
      }
    }
    case "customerName": {
      if (value) {
        return {
          ...state,
          customerName: value,
          customerNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          customerName: "",
          customerNameStatus: "unchecked",
        };
      }
    }
    case "rating": {
      if (value) {
        return {
          ...state,
          rating: value,
          ratingStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          rating: "",
          ratingStatus: "unchecked",
        };
      }
    }
     case "market": {
      if (value) {
        return {
          ...state,
          market: value,
          marketStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          market: "",
          marketStatus: "unchecked",
        };
      }
    }
    case "quantity": {
      if (value) {
        return {
          ...state,
          quantity: value,
          quantityStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          quantity: "",
          quantityStatus: "unchecked",
        };
      }
    }
     case "roleName": {
      if (value) {
        return {
          ...state,
          roleName: value,
          roleNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          roleName: "",
          roleNameStatus: "unchecked",
        };
      }
    }
     case "deliveryStatuses": {
      if (value) {
        return {
          ...state,
          deliveryStatuses: value,
          deliveryStatusesStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          deliveryStatuses: "",
          deliveryStatusesStatus: "unchecked",
        };
      }
    }
    case "ageofStock": {
      if (value) {
        return {
          ...state,
          ageofStock: value,
          ageofStockStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          ageofStock: "",
          ageofStockStatus: "unchecked",
        };
      }
    }
    case "fromDate": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          fromDate: value,
          fromDateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          fromDate: "",
          fromDateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          fromDate: value,
          fromDateStatus: "error",
        };
      }
    }
    case "toDate": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          toDate: value,
          toDateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          toDate: "",
          toDateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          toDate: value,
          toDateStatus: "error",
        };
      }
    }
    default:
      return state;
  }
};
